import { render } from "./LoadingMatchDetails.vue?vue&type=template&id=68a1067a&scoped=true"
import script from "./LoadingMatchDetails.vue?vue&type=script&lang=js"
export * from "./LoadingMatchDetails.vue?vue&type=script&lang=js"

import "../../assets/css/loading/index.css?vue&type=style&index=0&id=68a1067a&scoped=true&lang=css"
import "./LoadingMatchDetails.vue?vue&type=style&index=1&id=68a1067a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a1067a"]])

export default __exports__